import React, { useEffect, useRef } from 'react';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import dialogStyles from '../../common/dialogStyles';

interface AddDhcpReservationFormProps {
  reservationIp: string;
  reservationMac: string;
  description: string;
  setDescription: (val: string) => void;
  allowedInputCharacters: RegExp;
  isDescriptionValid: boolean;
  touched: { description: boolean };
  markDescriptionTouched: () => void;
}

const AddDhcpReservationForm: React.FC<AddDhcpReservationFormProps> = ({
  reservationIp,
  reservationMac,
  description,
  setDescription,
  allowedInputCharacters,
  isDescriptionValid,
  touched,
  markDescriptionTouched,
}) => {
  useEffect(() => {
    setDescription(reservationMac || '');
  }, []);

  const descriptionRef = useRef<HTMLInputElement | null>(null);

  const ShowValidationError = (!isDescriptionValid && touched.description) || !isDescriptionValid;

  const getFieldHelperText = () => {
    if (ShowValidationError) {
      if (description.trim().length === 0) {
        return 'DHCP reservation description cannot be empty.';
      }
      if (!allowedInputCharacters.test(description)) {
        return 'Only alphanumeric characters, hyphens (-), and underscores (_) are allowed. No spaces or symbols.';
      }
    }

    return `${description.length} / 20`;
  };

  return (
    <>
      <DialogContent sx={dialogStyles.dialogContentForm}>
        <Box sx={dialogStyles.reservationInfoStyles}>
          <Typography variant="subtitle1">MAC address: {reservationMac || ''}</Typography>
          <Typography variant="subtitle1">IP address: {reservationIp}</Typography>
        </Box>
        <Box display="flex" flexDirection="column">
          <TextField
            label="DHCP reservation description"
            value={description.toLowerCase()}
            onChange={(e) => setDescription(e.target.value)}
            onBlur={markDescriptionTouched}
            required
            error={ShowValidationError}
            helperText={getFieldHelperText()}
            inputRef={descriptionRef}
            multiline
            maxRows={3}
            inputProps={{ maxLength: 20 }}
            sx={dialogStyles.dialogContentFormTextField}
            placeholder="Enter description"
          />
        </Box>
      </DialogContent>
    </>
  );
};

export default AddDhcpReservationForm;
